<template>
    <div class="modal fade" id="notificationModal" tabindex="-1" aria-hidden="true" ref="notificationModal">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header justify-content-between align-items-center border-0 mx-4">
                    <h3 class="modal-title">
                        {{ modalTitle }}
                    </h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <component
                        v-if="notification && detailNotification"
                        :is="detailNotification"
                        :notification="notification"
                        @resolved="resolveNotification"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import BatteryLowDetail from '@/components/dashboard/notifications/BatteryLowDetail.vue';
import FallDetectedDetail from '@/components/dashboard/notifications/FallDetectedDetail.vue';

export default {
    components: {
        BatteryLowDetail,
        FallDetectedDetail,
    },
    props: {
        notification: Object,
    },
    data() {
        return {
            modalInstance: null,
        }
    },
    mounted() {
        this.modalInstance = new Modal(this.$refs.notificationModal)
    },
    beforeUnmount() {
        if (this.modalInstance) this.modalInstance.hide();
    },
    methods: {
        open() {
            this.modalInstance.show();
        },
        close() {
            this.modalInstance.hide();
            this.$emit("close");
        },
        resolveNotification() {
            this.$emit("resolved", this.notification);
            this.close();
        }
    },
    computed: {
        detailNotification() {
            if (!this.notification) return null;

            switch (this.notification.type) {
                case "battery_low":
                    return BatteryLowDetail;
                case "fall_detected":
                    return FallDetectedDetail;
                default:
                    return BatteryLowDetail;
            }
        },
        modalTitle() {
            if (!this.notification) return "";

            const { type, level } = this.notification;

            if (type === "battery_low") {
                return level === "critical"
                    ? this.$t("notifications.battery.titleCritical")
                    : this.$t("notifications.battery.titleWarning")
            }

            if (type === "fall_detected") {
                return this.$t("notifications.fall.title")
            }
        }
    }
}
</script>

<style scoped>
.modal_wrapper {
  background-color: #fff;
}
</style>